const TIRE_OFFER_TAB_KEYS = ['pending', 'accepted'] as const;

export type TabKey = (typeof TIRE_OFFER_TAB_KEYS)[number];

export function isTabKey(value: string): value is TabKey {
  return TIRE_OFFER_TAB_KEYS.includes(value as TabKey);
}
